<template>
  <app-page lean>
    <!-- Kopf wie die übrigen Verwaltungsseiten (Kundenwunsch 13.10.2026): leichter Titel, rechts die Aktionen mit Icon
         und Beschriftung (Handy: Aktualisieren als Icon-Knopf) -->
    <template #actions>
      <app-button v-if="!handy" icon="refresh" @click="refreshFileManager">Aktualisieren</app-button>
      <app-icon-button v-else icon="refresh" label="Aktualisieren" @click="refreshFileManager" />
      <app-button icon="upload" @click="uploadFiles">Hochladen</app-button>
    </template>
    <div class="app-page-pad">
      <DxFileManager
        ref="fileManager"
        :file-system-provider="customFileProvider"
        :allowed-file-extensions="allowedFileExtensions"
      >
        <DxPermissions
          :create="false"
          :copy="false"
          :move="false"
          :delete="true"
          :rename="false"
          :upload="true"
          :download="true"
        />
        <DxToolbar>
          <DxItem name="showNavPane" :visible="false" />
          <DxItem name="separator" :visible="false" />
          <DxItem name="create" :visible="false" />
          <DxItem name="upload" :visible="false" />
          <DxItem name="refresh" :visible="false" />
          <DxItem name="switchView" :visible="false" />
        </DxToolbar>
      </DxFileManager>
    </div>
  </app-page>
</template>

<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import { DxFileManager, DxPermissions, DxToolbar, DxItem } from "devextreme-vue/file-manager";
import CustomFileSystemProvider from "devextreme/file_management/custom_provider";

import axios from "axios";

export default {
  components: {
    DxFileManager,
    DxPermissions,
    DxToolbar,
    DxItem,
  },
  async mounted() {
    const documents = (await axios.get(`${this.dataUrl}`)).data;
    this.fileSystem = documents.map((d) => {
      d.size = d.file_size;
      return d;
    });
  },
  computed: {
    handy() {
      return !!(this.$dichte && this.$dichte.handy);
    },
    dataUrl() {
      return `${this.$store.state.baseUrl}customerdocuments`;
    },
  },
  data() {
    return {
      fileSystem: [],
      allowedFileExtensions:[".jpg", ".jepg", ".png"],
      customFileProvider: new CustomFileSystemProvider({
        getItems: this.getItems,
        uploadFileChunk: this.uploadFileChunk,
        downloadItems: this.downloadItems,
        deleteItem: this.deleteItem,
      }),
      // [
      //   {
      //     name: "MyFolder.jpg",
      //     size: 1024,
      //     dateModified: "2019/05/08",
      //     thumbnail: "/thumbnails/images/jpeg.ico",
      //     isDirectory: true,
      //     items: [],
      //   },
      // ],
    };
  },
  methods: {
    uploadFiles() {
      // Trigger the FileManager's upload command
      const fileManagerInstance = this.$refs.fileManager.instance;
      if (fileManagerInstance) {
        // Execute the upload command which opens the file selection dialog
        fileManagerInstance.executeCommand('upload');
      }
    },
    refreshFileManager() {
      // Refresh the FileManager
      const fileManagerInstance = this.$refs.fileManager.instance;
      if (fileManagerInstance) {
        fileManagerInstance.refresh();
      }
    },
    async getItems() {
      return (await axios.get(`${this.dataUrl}`)).data;
    },
    async deleteItem(item) {
      return await axios.delete(`${this.dataUrl}?file_name=${item.name}`);
    },
    async downloadItems(items) {
      const downloadInfo = (
        await axios.get(`${this.dataUrl}?file_name=${items[0].name}`)
      ).data;
      this.downloadFile(downloadInfo.downloadUrl);
    },
    async uploadFileChunk(fileData, uploadInfo) {
      if (uploadInfo.chunkIndex == 0) {
        let uploadData = await axios.post(`${this.dataUrl}`, {
          name: fileData.name,
          file_type: fileData.type,
        });
        uploadData = uploadData.data;

        return await axios.create().put(uploadData.uploadUrl, fileData);
      } else {
        return true;
      }
    },
    downloadFile(filePath) {
      var link = document.createElement("a");
      link.href = filePath;
      link.download = filePath.substr(filePath.lastIndexOf("/") + 1);
      link.click();
    },
  },
};
</script>

<style>
/* .dx-drawer-panel-content.dx-drawer-panel-content-initial {
    display: none !important;
} */
</style>